import PageHero from "../PageHero"

export default function ModuleHero({ module }) {
    return <PageHero {...module} />
}
